var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-table',{staticClass:"simple-table",attrs:{"row-component":_vm.rowComponent,"columns":_vm.columns,"data":[_vm.contentItemResource]}})}
var staticRenderFns = []

export { render, staticRenderFns }